import styled from 'styled-components';
import { rem } from '@mantine/core';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';

export const TableTitle = styled.div`
	margin-top: ${rem(32)};
	color: ${({ theme }) => theme.v2.color.neutral[900]};
	text-align: left;
	margin-bottom: ${rem(16)};
	${Text}:nth-of-type(2) {
		padding-left: ${rem(8)};
		padding-right: ${rem(8)};
	}
`;

export const CounterpartySignatureWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
`;

export const InvestorSignatureWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
`;

export const DocumentNameCell = styled.div`
	display: flex;
	align-items: center;
	gap: var(--mantine-spacing-sm);
	width: 100%;
	min-width: 0;
	overflow: hidden;
	.document-name-text {
		min-width: 0;
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const TruncatedTextCell = styled.div`
	width: 100%;
	min-width: 0;
	overflow: hidden;
	.truncated-text {
		min-width: 0;
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
